import React from 'react';
import '@assets/css/spinner.css';

const Spinner = () => (
  <div className='loader-container'>
    <div className='spinner' />
  </div>
);

export default Spinner;